import { render } from "./ViewHire.vue?vue&type=template&id=f4672b40&scoped=true"
import script from "./ViewHire.vue?vue&type=script&lang=js"
export * from "./ViewHire.vue?vue&type=script&lang=js"

import "./ViewHire.vue?vue&type=style&index=0&id=f4672b40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4672b40"]])

export default __exports__